<app-wrapper>
  <div class="mb-9">
    <div class="mb-4">
      <div class="row g-3">
        <div class="col-auto">
          <h2>
            <div class="d-inline pe-2 cursor-pointer" (click)="back()" title="Назад">
              <i class="fa-solid fa-arrow-left"></i>
            </div>
            Продукт
          </h2>
        </div>
        <div class="col-auto flex-grow-1">
        </div>
        <div class="col-auto">
          <button (click)="save()" [disabled]="form.invalid" class="btn btn-primary">
            <i class="fa-solid fa-save"></i>&nbsp;Сохранить
          </button>
        </div>
      </div>
    </div>

    <div class="row g-5">
      <div class="col-12">
        <form #form="ngForm" class="card p-4">
          <div class="row">
            <div class="col-md-4 col-lg-2">
              <div class="form-group">
                <div class="form-floating mb-3">
                  <input type="text" name="name" [(ngModel)]="model.name" class="form-control"
                    required placeholder="Название">
                    <label>Название</label>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-lg-2">
                <div class="form-group">
                  <div class="form-floating mb-3">
                    <input type="text" name="price" [(ngModel)]="model.price" class="form-control"
                      required placeholder="Цена(р.)">
                      <label>Цена(р.)</label>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 col-lg-2">
                  <div class="form-group">
                    <div class="form-floating mb-3">
                      <input type="text" name="oldPrice" [(ngModel)]="model.oldPrice" class="form-control"
                        placeholder="Старая цена(р.)">
                        <label>Старая цена(р.)</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3 col-lg-2">
                    <div class="form-group">
                      <div class="form-check form-switch mb-3">
                        <input class="form-check-input" type="checkbox" name="isPublished"
                          [(ngModel)]="model.isPublished">
                          <label class="form-check-label" for="flexSwitchCheckDefault">Опубликован</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3 col-lg-2">
                      <div class="form-group">
                        <div class="form-check form-switch mb-3">
                          <input class="form-check-input" type="checkbox" name="isNew"
                            [(ngModel)]="model.isNew">
                            <label class="form-check-label" for="flexSwitchCheckDefault">Новинка</label>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3 col-lg-2">
                        <div class="form-group">
                          <div class="form-check form-switch mb-3">
                            <input class="form-check-input" type="checkbox" name="isFavorite"
                              [(ngModel)]="model.isFavorite">
                              <label class="form-check-label" for="flexSwitchCheckDefault">Избранное</label>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4 col-lg-2">
                          <div class="form-group">
                            <div class="form-floating mb-3">
                              <input type="text" name="code" [(ngModel)]="model.code" class="form-control"
                                placeholder="Артикул">
                                <label>Артикул</label>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4 col-lg-2">
                            <div class="form-group">
                              <div class="form-floating mb-3">
                                <input type="number" name="order" [(ngModel)]="model.order" class="form-control"
                                  placeholder="Сортировка">
                                  <label>Сортировка</label>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4 col-lg-2">
                              <div class="form-group">
                                <div class="form-floating mb-3">
                                  <input type="text" name="barcode" [(ngModel)]="model.barcode" class="form-control"
                                    placeholder="Штрих-код">
                                    <label>Штрих-код</label>
                                  </div>
                                </div>
                              </div>
                              <div class="col-12">
                                <div class="form-group">
                                  <label class="w-100">
                                    Категории
                                    <div class="categories">
                                      @for (item of model.categoryIds; track item) {
                                        <div class="item">
                                          {{ getCategoryName(item) }}
                                          <span class="p-2 cursor-pointer text-danger" (click)="removeCategory(item)">
                                            <i class="fa fa-times"></i>
                                          </span>
                                        </div>
                                      }
                                    </div>
                                    <div class="d-flex mb-3">
                                      <div class="form-floating">
                                        <select name="selectLinkCategory" [(ngModel)]="selectLinkCategory"
                                          class="form-select me-2 w-auto mw-150" placeholder="Категория">
                                          <option [ngValue]="undefined">Категория не выбрана</option>
                                          @for (current of categories; track current) {
                                            <ng-container
                                              [ngTemplateOutlet]="itemTemplateRef"
                                            [ngTemplateOutletContext]="{item: current, level: 0}"></ng-container>
                                          }
                                        </select>
                                        <label>Категория</label>
                                      </div>
                                      <button type="button" (click)="addCategory()" class="btn btn-primary" [ngClass]="{'disabled': !this.selectLinkCategory}">
                                        <i class="fa-solid fa-plus"></i>&nbsp;Добавить
                                      </button>
                                    </div>
                                  </label>
                                </div>
                              </div>
                              <div class="col-12 mb-4">
                                <div class="form-group">
                                  <div class="form-floating mb-3">
                                    <textarea [(ngModel)]="model.description" name="description" placeholder="Описание"
                                    rows="5" class="form-control"></textarea>
                                    <label>
                                      Описание
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6 mb-4">
                                <div class="d-flex">
                                  @for (image of model.images; track image) {
                                    <div class="image mb-2 me-2">
                                      <img [src]="image.path" [title]="image.originalName" />
                                      <div class="overflow">
                                        <div class="remove" (click)="removeImage(image)">
                                          <i class="fa-solid fa-times"></i>
                                        </div>
                                        <div class="move">
                                          <div class="ps-3 p-2 cursor-pointer" (click)="moveImage(image, true)">
                                            <i class="fa-solid fa-arrow-left"></i>
                                          </div>
                                          <div class="p-2 pe-3 cursor-pointer" (click)="moveImage(image, false)">
                                            <i class="fa-solid fa-arrow-right"></i>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  }
                                </div>
                                <label class="w-100">
                                  Новое изображение
                                  <input type="file" (change)="selectFile($event)" class="form-control"
                                    accept="image/*" />
                                  </label>
                                </div>

                                <div class="col-12">
                                  Модификаторы
                                  <button class="btn btn-primary" (click)="addModificator()">
                                    <i class="fa-solid fa-plus"></i>&nbsp;Добавить
                                  </button>
                                  <div class="modificators mb-2">
                                    @for (modificator of model.modificators; track modificator; let index = $index) {
                                      <div class="modificator">
                                        <ng-container [ngTemplateOutlet]="modificatorTemplateRef"
                                          [ngTemplateOutletContext]="{modificator: modificator, index: index}">
                                        </ng-container>
                                      </div>
                                    }
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                        @if (isBusy) {
                          <div class="overlay">
                            <i class="fa-solid fa-spinner fa-spin"></i>
                          </div>
                        }
                      </div>
                    </app-wrapper>

                    <ng-template #itemTemplateRef let-item="item" let-level="level">
                      <option [value]="item.id">{{ getSelectPrefix(level) }}{{ item.name }}</option>
                      @for (current of item.categories; track current) {
                        <ng-container [ngTemplateOutlet]="itemTemplateRef"
                        [ngTemplateOutletContext]="{item: current, level: level + 1}"></ng-container>
                      }
                    </ng-template>

                    <ng-template #modificatorTemplateRef let-modificator="modificator" let-index="index">
                      <div class="row">
                        <div class="col-md-4 col-lg-2">
                          <div class="form-group">
                            <div class="form-floating mb-3">
                              <input name="modificator_name_{{ index }}" class="form-control" [(ngModel)]="modificator.name"
                                placeholder="Название" />
                                <label>Название</label>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4 col-lg-2">
                            <div class="form-group">
                              <div class="form-floating mb-3">
                                <input name="modificator_price_{{ index }}" class="form-control" [(ngModel)]="modificator.price"
                                  placeholder="Цена" />
                                  <label>Цена</label>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4 col-lg-2">
                              <div class="form-group">
                                <div class="form-floating mb-3">
                                  <input name="modificator_defaultCount_{{ index }}" class="form-control"
                                    placeholder="Количество по умолчанию" [(ngModel)]="modificator.defaultCount" />
                                    <label>Количество по умолчанию</label>
                                  </div>
                                </div>
                              </div>

                              <div class="col-md-4 col-lg-2">
                                <div class="form-group">
                                  <div class="form-floating mb-3">
                                    <input name="modificator_minCount_{{ index }}" class="form-control"
                                      [(ngModel)]="modificator.minCount" placeholder="Минимальное количество" />
                                      <label>Минимальное количество</label>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-md-4 col-lg-2">
                                  <div class="form-group">
                                    <div class="form-floating mb-3">
                                      <input name="modificator_maxCount_{{ index }}" class="form-control"
                                        [(ngModel)]="modificator.maxCount" placeholder="Максимальное количество" />
                                        <label>Максимальное количество</label>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="col-md-4 col-lg-2">
                                    <div class="form-group">
                                      <div class="form-floating mb-3">
                                        <input name="modificator_order_{{ index }}" class="form-control" [(ngModel)]="modificator.order" placeholder="Порядок" />
                                        <label>Порядок</label>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="col-md-4 col-lg-2">
                                    <div class="form-group">
                                      <div class="form-check form-switch mb-3">
                                        <input class="form-check-input" type="checkbox" name="modificator_isRequried_{{ index }}"
                                          [(ngModel)]="modificator.isRequried">
                                          <label class="form-check-label" for="flexSwitchCheckDefault">Обязательный</label>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-12 mb-4">
                                      @if (modificator.image) {
                                        <div class="image mb-2 mt-2">
                                          <img [src]="modificator.image.path" [title]="modificator.image.originalName" />
                                          <div class="overflow">
                                            <div class="remove" (click)="removeModificatorImage(modificator)">
                                              <i class="fa-solid fa-times"></i>
                                            </div>
                                          </div>
                                        </div>
                                      }
                                      <label class="w-100">
                                        Новое изображение
                                        <input type="file" (change)="selectModificatorFile(modificator, $event)" class="form-control"
                                          accept="image/*" />
                                        </label>
                                      </div>
                                      <div class="col-12">
                                        <button class="btn btn-primary mb-2" (click)="addModificator(modificator)">
                                          <i class="fa-solid fa-plus"></i>&nbsp;Добавить
                                        </button>&nbsp;
                                        <button class="btn btn-danger mb-2" (click)="removeModificator(modificator)">
                                          <i class="fa-solid fa-trash"></i>&nbsp;Удалить
                                        </button>
                                      </div>
                                    </div>


                                    @if (modificator.child?.length > 0) {
                                      <div class="children">
                                        @for (child of modificator.child; track child; let childIndex = $index) {
                                          <div class="child">
                                            <ng-container [ngTemplateOutlet]="modificatorTemplateRef"
                                            [ngTemplateOutletContext]="{modificator: child, index: index + ' ' + childIndex}"></ng-container>
                                          </div>
                                        }
                                      </div>
                                    }

                                  </ng-template>